<template>
  <main>
    <div class="pra_all">
      <Tou></Tou>
      <div class="dad">
        <ul class="routing">
          <li>
            <span @click="Instructions_YI" class="Instructions">常见问题</span>
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-chevron-right"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
            <span class="Instructions" @click="Instructions_ER">账户常见问题</span>
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-chevron-right"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
            <span class="Instructions current">如何找到其他海星云小伙伴</span>
            <!-- <div class="border_linear"></div> -->
          </li>
        </ul>
        <ul class="pra_content tong">
          <li class="PC_li">
            <div class="title">
              <div>
                <div>问题:</div>如何进入海星云QQ群?
              </div>
            </div>
            <div class="answer">
              可以输入下列群号搜索进群。（请注意为防止机器人进群，需在进群后30s内填写验证码。如果错过请重新进群）
              <br />QQ群
              <br />
              <span>
                1.海星云qq1群（已满） 375135205
                <br />
              </span>
              <span>
                2.海星云qq2群（已满） 725586440
                <br />
              </span>
              <span>
                3.海星云qq3群（已满） 138833635
                <br />
              </span>
              <span>
                4.海星云qq4群（已满） 376875189
                <br />
              </span>
              <span>
                5.海星云qq5群（已满） 755325869
                <br />
              </span>
              <span>
                6.海星云qq6群（已满） 897692973
                <br />
              </span>
              <span>
                7.海星云qq7群（已满） 939130535
                <br />
              </span>
              <span>
                8.海星云qq8群（未满） 765311390
                <br />
              </span>
              <span>
                8.海星云qq9群（未满） 813396460
                <br />
              </span>
              <br />
            </div>
          </li>
          <li class="PC_li">
            <div class="title">
              <div>
                <div>问题:</div>如何申请进入海星云微信群?
              </div>
            </div>
            <div class="answer">
              可以扫描下列二维码。
              <br />
              <span>
                添加海星云客服。客服拉人进群。（ps:请诸位亲们添加客服时注明哪里知道的海星云，如：b站up、朋友推荐、网上搜索等等。）
                <br />
              </span>
              <span>
                二维码:
                <br />
                <span>
                  <img src="../../../../static/plem06.png" alt />
                </span>
              </span>
              <br />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </main>
</template>

<script>
import Tou from '@/components/Tou.vue'
export default {
  components: {Tou},
  data () {
    return {
    }
  },
  mounted () {},
  methods: {
    Instructions_YI () {
      this.$router.push('./faq')
    },
    Instructions_ER () {
      this.$router.push('./Account')
    }
  }
}
</script>

<style lang="scss" scoped>
html,
body {
  width: 100%;
  height: 100%;
}
.pra_all {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #100e2e;
}
.pra_content {
  width: 1070px;
  min-height: 300px;
  padding: 10px 20px 30px 20px;
  margin-top: 30px;
}
.dad {
  margin-top: 170px;
  background-color: #100e2e;
}
.title {
  font-size: 18.3px;
  color: #ffffff;
  width: 1070px;
  font-weight: 900;
}
.title div {
  // text-indent: 25px;
  display: inline-block;
}
.tong {
  margin: 15px auto 0;
  background-color: #0d0b26;
  padding-top: 30px;
}
.PC_li {
  padding: 5px 0 6px 0;
  margin-bottom: 25px;
}
.answer {
  // text-indent: 20px;
  font-size: 16px;
  // color: #ffffff9c;
  color: white;
  width: 100%;
  min-height: 100px !important;
  border-radius: 3px;
  margin-top: 15px;
  padding: 5px 30px;
  background-color: #252e45;
}
.answer div {
  display: inline-block;
}
.da {
  font-size: 16px;
  margin-bottom: 10px;
}
.answer span {
  display: block;
  text-indent: 25px;
}
@media screen and (max-width: 1000px) {
  .tong {
    width: 100%;
  }
  .dad {
    margin-top: 100px;
    background-color: #100e2e;
  }
}
.routing {
  height: 20px;
  width: 1070px;
  margin-top: 70px;
  font-size: 12px;
  line-height: 20px;
  margin: 0 auto;
}
.routing li {
  display: inline;
  position: relative;
}
.Instructions:hover {
  color: white;
  cursor: pointer;
}
@media screen and (max-width: 1000px) {
  .routing {
    width: 100%;
  }
}
.current {
  color: #ffffff94;
}
.current:hover {
  color: #ffffff94 !important;
}
.border_linear {
  width: 100% !important;
  height: 1px !important;
  position: absolute;
  left: 0;
  bottom: 0;
  background: linear-gradient(
    to right,
    rgba(190, 187, 187, 0.1) 0%,
    rgba(190, 187, 187, 0.2) 10%,
    rgba(190, 187, 187, 0.3) 20%,
    rgba(190, 187, 187, 0.4) 30%,
    rgba(190, 187, 187, 0.5) 40%,
    rgba(190, 187, 187, 0.8) 50%,
    rgba(190, 187, 187, 0.5) 60%,
    rgba(190, 187, 187, 0.4) 70%,
    rgba(190, 187, 187, 0.3) 80%,
    rgba(190, 187, 187, 0.2) 90%,
    rgba(190, 187, 187, 0.1) 100%
  );
}
@media screen and (min-width: 999px) and (max-width: 1199px) {
  .dad {
    margin-top: 200px;
  }
}
@media screen and (min-width: 768px) and (max-width: 998px) {
  .dad {
    margin-top: 180px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommonProblem/Account/friend.vue